export function parseBarEtarianStats(etarianStats) {
  return Object.keys(etarianStats).reduce((res, gender) => {
    const gendered = Object.keys(etarianStats[gender]).map(ageRange => ({
      gender,
      category: ageRange,
      value: etarianStats[gender][ageRange],
    }));

    return res.concat(gendered);
  }, []);
}

export function parsePieEtarianStats(etarianStats) {
  return Object.keys(etarianStats).reduce(
    (acc, gender) => {
      const sum = Object.values(etarianStats[gender]).reduce(
        (res, val) => res + val,
        0,
      );

      return [
        ...acc,
        {
          name: gender,
          value: sum,
        },
      ];
    },
    [],
  );
}
